import React, { Component } from "react";
import image from "../../../assets/images/seo-ux.png";
import "../../../styles/pages/seo/SEOUX.css";

export default class SEOUX extends Component {
  render() {
    return (
      <div className="SEOUX gutters">
        <div className="text-container">
          <div className="g-title on-scroll-anim">
            IMPROVING THE USER EXPERIENCE
          </div>
          <div className="g-sub-text on-scroll-anim">
            This is the cornerstone of modern SEO. The amount of time users
            spend on your website is one of the most vital factors in
            determining your placement in search results.
            <br />
            <br />
            We track all user interactions on your site, analyze their behavior,
            and make edits accordingly to keep them on the site as long as
            possible.
          </div>
        </div>
        <img className="on-scroll-anim" src={image} alt="UX design." />
      </div>
    );
  }
}
